import React, { Component } from 'react'
import Navigation from './components/navigation';
import Hero from './components/Hero';
import TrustStrip from './components/TrustStrip';
import Stats from './components/Stats';
import Problem from './components/Problem';
import HowItWorks from './components/HowItWorks';
import Features from './components/features';
import Showcase from './components/Showcase';
import Mission from './components/Mission';
import Pricing from './components/Pricing';
import StudentForm from './components/StudentForm';
import ClinicForm from './components/ClinicForm';
import Faq from './components/Faq';
import CtaBand from './components/CtaBand';
import Team from './components/Team';
import Newsletter from './components/newsletter';
import Testimonials from './components/testimonials';
import Contact from './components/contact';
import Mentions from './components/Mentions';
import Footer from './components/Footer';
import Modal from './components/Modal';

export class App extends Component {
  constructor(props) {
    super(props);
    this.state = { modal: null };
  }

  componentDidMount() {
    this._initIcons();
  }

  componentDidUpdate() {
    this._initIcons();
  }

  _initIcons() {
    const tick = () => {
      if (window.lucide && window.lucide.createIcons) {
        try { window.lucide.createIcons(); } catch (e) { /* noop */ }
      } else {
        setTimeout(tick, 140);
      }
    };
    tick();
  }

  openModal = (which) => {
    this.setState({ modal: which });
  }

  closeModal = () => {
    this.setState({ modal: null });
  }

  render() {
    const { modal } = this.state;

    return (
      <div>
        <Navigation />
        <Hero />
        <TrustStrip />
        <Stats />
        <Problem />
        <HowItWorks />
        <Testimonials />
        <Features />
        <Showcase />
        <Mission />
        <Pricing onOpenModal={this.openModal} />
        <Faq />
        <CtaBand />
        <Team />
        <Newsletter />
        <Contact />
        <Footer onOpenModal={this.openModal} />

        {/* Modals */}
        {modal === 'student' && (
          <Modal onClose={this.closeModal}>
            <StudentForm />
          </Modal>
        )}
        {modal === 'clinic' && (
          <Modal onClose={this.closeModal}>
            <ClinicForm />
          </Modal>
        )}
        {modal === 'legal' && (
          <Modal onClose={this.closeModal} wide>
            <Mentions />
          </Modal>
        )}
      </div>
    )
  }
}

export default App;
